const HealthIssueOutlined = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Property 1=health_issue">
      <path
        id="icon/action/favorite_border_24px"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4.91495C13.09 3.63495 14.76 2.82495 16.5 2.82495C19.58 2.82495 22 5.24495 22 8.32495C22 12.1018 18.6056 15.1799 13.4627 19.8435L13.45 19.855L12 21.175L10.55 19.865L10.5105 19.8291C5.38263 15.1692 2 12.0953 2 8.32495C2 5.24495 4.42 2.82495 7.5 2.82495C9.24 2.82495 10.91 3.63495 12 4.91495ZM12 18.475L12.1 18.375C16.86 14.065 20 11.215 20 8.32495C20 6.32495 18.5 4.82495 16.5 4.82495C14.96 4.82495 13.46 5.81495 12.94 7.18495H11.07C10.54 5.81495 9.04 4.82495 7.5 4.82495C5.5 4.82495 4 6.32495 4 8.32495C4 11.215 7.14 14.065 11.9 18.375L12 18.475Z"
        fill="white"
      />
      <path id="Path" d="M11.3 13.5H12.8V15H11.3V13.5Z" fill="white" />
      <path id="Path_2" d="M11.3 9H12.8V12.5H11.3V9Z" fill="white" />
    </g>
  </svg>
);

export default HealthIssueOutlined;
